export type BaseProject = {
  name: string;
  projectIdentifier: string;
};

export function projectGetKey(item: BaseProject) {
  return item.projectIdentifier;
}

export function projectGetValue(item: BaseProject) {
  return item.name;
}
